import React from "react";
import { createRoot } from "react-dom/client";
// import { register as registerErrorHandler } from "./errorHandler";
// import { register as registerServiceWorker } from "./serviceWorker";
import Root from "./Root";

// if (!DEV) {
//   registerErrorHandler();
// }

// Render app into root element
createRoot(document.getElementById("root")!).render(<Root />);

// if (!DEV && BUILD_TARGET === "web") {
//   registerServiceWorker();
// }
